export default __webpack_public_path__ + "static/media/design-7.5a034875.png";